export default ({ props, path, state }) => {
  if (state.get('node.selectedNode.id') !== props.id) return path.true()

  return path.false()
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/isNewNodeSelected.js